import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <Loader2 className="h-8 w-8 animate-spin text-forest" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
